/**
 * Expense (Xarajat) schemalar — do'kon xarajatlari (ijara, kommunal, maosh, ...)
 *
 * Multi-tenant: har xarajat storeId bilan (RLS). Foyda-zarar (P&L) hisobida
 * xarajatlar sof foydadan ayriladi.
 */
import { z } from 'zod';
import { currencyEnum } from './product.schema.js';
// ─── Xarajat turlari ──────────────────────────────────────────────
export const expenseCategoryEnum = z.enum([
    'IJARA', // ijara haqi
    'KOMMUNAL', // svet, suv, gaz, internet
    'MAOSH', // xodimlar oyligi
    'TRANSPORT', // yetkazib berish, yo'l
    'SOLIQ', // soliq, yig'im
    'TOVAR', // tovar/material sotib olish (umumiy)
    'BOSHQA', // boshqa
]);
export const EXPENSE_CATEGORY_LABELS = {
    IJARA: 'Ijara',
    KOMMUNAL: 'Kommunal',
    MAOSH: 'Maosh',
    TRANSPORT: 'Transport',
    SOLIQ: 'Soliq',
    TOVAR: 'Tovar',
    BOSHQA: 'Boshqa',
};
// ─── Create ───────────────────────────────────────────────────────
export const createExpenseSchema = z.object({
    amount: z.number().positive("Summa 0 dan katta bo'lishi kerak").max(1_000_000_000_000),
    currency: currencyEnum.default('UZS'),
    category: expenseCategoryEnum,
    note: z.string().max(500).optional(),
    // Xarajat sanasi (ISO yoki YYYY-MM-DD). Bo'sh bo'lsa — hozir.
    date: z.coerce.date().optional(),
});
// ─── Update ───────────────────────────────────────────────────────
export const updateExpenseSchema = createExpenseSchema.partial();
// ─── Query ────────────────────────────────────────────────────────
export const expenseQuerySchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    limit: z.coerce.number().int().min(1).max(200).default(50),
    category: expenseCategoryEnum.optional(),
    dateFrom: z.string().optional(), // ISO
    dateTo: z.string().optional(),
});
//# sourceMappingURL=expense.schema.js.map